import { html } from 'lit';
import componentStyles from './monogram-panel.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from 'lit-html/directives/class-map';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import hfMark from '../icon/assets/icons/hf-mark.svg';

export default class MonogramPanel extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Title of the panel
       */
      title: { type: String },
      /**
       * Icon card objects.
       * @type {{title: string, bodyText: string, icon: string, url: string}}
       */
      items: { type: Object },
    };
  }

  constructor() {
    super();
    this.imageOrientation = 'landscape';
  }

  render() {
    return html`
      <div class="monogram-panel">
        <div
          class="${classMap({
            'monogram-panel__wrapper': true,
            [`monogram-panel__wrapper--rows-${Math.ceil(
              this.items.length / 3
            )}`]: true,
          })}"
        >
          <div class="monogram-panel__title-wrapper">
            ${this.title
              ? html`<hf-heading
                  level="2"
                  levelStyle="heading2"
                  class="monogram-panel__title"
                  >${this.title}</hf-heading
                >`
              : ''}
            <span class="monogram-panel__icon">${unsafeHTML(hfMark)}</span>
          </div>
          <ul class="monogram-panel__card-wrapper">
            ${this.items.map(item => {
              return html` <li class="monogram-panel__card">
                <hf-monogram-card
                  title=${item.title}
                  icon=${item.icon}
                  bodyText=${item.bodyText}
                  url=${item.url}
                  target=${item.target}
                  levelHeader=${this.title ? '3' : '2'}
                ></hf-monogram-card>
              </li>`;
            })}
          </ul>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-monogram-panel', MonogramPanel);
